// Use class 1 or 6 to view mock assessments for the class

import {
  EAcademicSection,
  EStandardLevel,
} from '../../apis/academics/academicsClassesAndCourses.interfaces';
import {
  EAssessmentType,
  EAssessmentStatus,
  IAcademicsAssessmentClassMap,
  IAcademicsAssessmentStatistics,
} from '../../apis/academics/academicsAssessments.interfaces';
import { mockUserAction } from '../users/userAction';

export const academicsAssessmentClassesMock: IAcademicsAssessmentClassMap[] = [
  {
    id: 1,
    classDetails: {
      name: 'Class 1',
      standardLevel: EStandardLevel.CLASS_1,
      section: EAcademicSection.A,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [
        {
          assessmentId: 'ASSESS-CLASS-1-EXAM-1',
          name: 'Class 1 - Mid Term Exam',
          description: 'Mid term examination for Class 1',
          assessmentType: EAssessmentType.EXAM,
          status: EAssessmentStatus.GRADED,
          classId: 1,
          maxScore: 100,
          totalStudents: 95,
          averageScore: 82.5,
          averagePercentage: 82.5,
          scheduledDate: '2024-03-15T09:00:00.000Z',
          conductedDate: '2024-03-15T10:30:00.000Z',
          gradedDate: '2024-03-20T18:00:00.000Z',
          weightage: 30,
          actions: {
            created: mockUserAction,
          },
        },
      ],
      [EAssessmentType.TEST]: [
        {
          assessmentId: 'ASSESS-CLASS-1-TEST-1',
          name: 'Class 1 - Unit Test 1',
          description: 'First unit test for Class 1',
          assessmentType: EAssessmentType.TEST,
          status: EAssessmentStatus.GRADED,
          classId: 1,
          maxScore: 50,
          totalStudents: 98,
          averageScore: 42.5,
          averagePercentage: 85,
          scheduledDate: '2024-02-10T09:00:00.000Z',
          conductedDate: '2024-02-10T10:30:00.000Z',
          gradedDate: '2024-02-12T18:00:00.000Z',
          weightage: 15,
          actions: {
            created: mockUserAction,
          },
        },
        {
          assessmentId: 'ASSESS-CLASS-1-TEST-2',
          name: 'Class 1 - Unit Test 2',
          description: 'Second unit test for Class 1',
          assessmentType: EAssessmentType.TEST,
          status: EAssessmentStatus.IN_PROGRESS,
          classId: 1,
          maxScore: 50,
          totalStudents: 97,
          averageScore: 0,
          averagePercentage: 0,
          scheduledDate: '2024-03-10T09:00:00.000Z',
          conductedDate: '2024-03-10T10:30:00.000Z',
          weightage: 15,
          actions: {
            created: mockUserAction,
          },
        },
      ],
      [EAssessmentType.ASSIGNMENT]: [
        {
          assessmentId: 'ASSESS-CLASS-1-ASSIGN-1',
          name: 'Class 1 - Math Assignment',
          description: 'Mathematics assignment for Class 1',
          assessmentType: EAssessmentType.ASSIGNMENT,
          status: EAssessmentStatus.GRADED,
          classId: 1,
          maxScore: 20,
          totalStudents: 100,
          averageScore: 17.5,
          averagePercentage: 87.5,
          dueDate: '2024-02-25T17:00:00.000Z',
          conductedDate: '2024-02-25T17:00:00.000Z',
          gradedDate: '2024-02-28T18:00:00.000Z',
          weightage: 10,
          actions: {
            created: mockUserAction,
          },
        },
      ],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [
        {
          assessmentId: 'ASSESS-CLASS-1-QUIZ-1',
          name: 'Class 1 - Science Quiz',
          description: 'Quick science quiz for Class 1',
          assessmentType: EAssessmentType.QUIZ,
          status: EAssessmentStatus.GRADED,
          classId: 1,
          maxScore: 10,
          totalStudents: 99,
          averageScore: 8.5,
          averagePercentage: 85,
          conductedDate: '2024-02-05T10:00:00.000Z',
          gradedDate: '2024-02-06T18:00:00.000Z',
          weightage: 5,
          actions: {
            created: mockUserAction,
          },
        },
      ],
      [EAssessmentType.MID_TERM]: [
        {
          assessmentId: 'ASSESS-CLASS-1-MIDTERM-1',
          name: 'Class 1 - Mid Term Assessment',
          description: 'Mid term comprehensive assessment',
          assessmentType: EAssessmentType.MID_TERM,
          status: EAssessmentStatus.SCHEDULED,
          classId: 1,
          maxScore: 100,
          scheduledDate: '2024-04-15T09:00:00.000Z',
          weightage: 25,
          actions: {
            created: mockUserAction,
          },
        },
      ],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 6,
    averageScore: 37.75,
    averagePercentage: 75.5,
    completionRate: 66.7,
  },
  {
    id: 2,
    classDetails: {
      name: 'Class 2',
      standardLevel: EStandardLevel.CLASS_2,
      section: EAcademicSection.A,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 3,
    classDetails: {
      name: 'Class 3',
      standardLevel: EStandardLevel.CLASS_3,
      section: EAcademicSection.A,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 4,
    classDetails: {
      name: 'Class 4',
      standardLevel: EStandardLevel.CLASS_4,
      section: EAcademicSection.A,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 5,
    classDetails: {
      name: 'Class 5',
      standardLevel: EStandardLevel.CLASS_5,
      section: EAcademicSection.A,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 6,
    classDetails: {
      name: 'Class 6',
      standardLevel: EStandardLevel.CLASS_6,
      section: EAcademicSection.A,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [
        {
          assessmentId: 'ASSESS-CLASS-6-EXAM-1',
          name: 'Class 6 - Annual Exam',
          description: 'Annual examination for Class 6',
          assessmentType: EAssessmentType.EXAM,
          status: EAssessmentStatus.GRADED,
          classId: 6,
          maxScore: 100,
          totalStudents: 92,
          averageScore: 78.5,
          averagePercentage: 78.5,
          scheduledDate: '2024-03-20T09:00:00.000Z',
          conductedDate: '2024-03-20T10:30:00.000Z',
          gradedDate: '2024-03-25T18:00:00.000Z',
          weightage: 30,
          actions: {
            created: mockUserAction,
          },
        },
      ],
      [EAssessmentType.TEST]: [
        {
          assessmentId: 'ASSESS-CLASS-6-TEST-1',
          name: 'Class 6 - Periodic Test 1',
          description: 'First periodic test for Class 6',
          assessmentType: EAssessmentType.TEST,
          status: EAssessmentStatus.GRADED,
          classId: 6,
          maxScore: 50,
          totalStudents: 95,
          averageScore: 40.5,
          averagePercentage: 81,
          scheduledDate: '2024-02-15T09:00:00.000Z',
          conductedDate: '2024-02-15T10:30:00.000Z',
          gradedDate: '2024-02-17T18:00:00.000Z',
          weightage: 15,
          actions: {
            created: mockUserAction,
          },
        },
        {
          assessmentId: 'ASSESS-CLASS-6-TEST-2',
          name: 'Class 6 - Periodic Test 2',
          description: 'Second periodic test for Class 6',
          assessmentType: EAssessmentType.TEST,
          status: EAssessmentStatus.GRADED,
          classId: 6,
          maxScore: 50,
          totalStudents: 94,
          averageScore: 41.0,
          averagePercentage: 82,
          scheduledDate: '2024-03-05T09:00:00.000Z',
          conductedDate: '2024-03-05T10:30:00.000Z',
          gradedDate: '2024-03-07T18:00:00.000Z',
          weightage: 15,
          actions: {
            created: mockUserAction,
          },
        },
      ],
      [EAssessmentType.ASSIGNMENT]: [
        {
          assessmentId: 'ASSESS-CLASS-6-ASSIGN-1',
          name: 'Class 6 - English Assignment',
          description: 'English language assignment',
          assessmentType: EAssessmentType.ASSIGNMENT,
          status: EAssessmentStatus.GRADED,
          classId: 6,
          maxScore: 20,
          totalStudents: 98,
          averageScore: 16.5,
          averagePercentage: 82.5,
          dueDate: '2024-02-20T17:00:00.000Z',
          conductedDate: '2024-02-20T17:00:00.000Z',
          gradedDate: '2024-02-23T18:00:00.000Z',
          weightage: 10,
          actions: {
            created: mockUserAction,
          },
        },
        {
          assessmentId: 'ASSESS-CLASS-6-ASSIGN-2',
          name: 'Class 6 - Science Project',
          description: 'Science project assignment',
          assessmentType: EAssessmentType.ASSIGNMENT,
          status: EAssessmentStatus.COMPLETED,
          classId: 6,
          maxScore: 20,
          totalStudents: 96,
          averageScore: 0,
          averagePercentage: 0,
          dueDate: '2024-03-20T17:00:00.000Z',
          conductedDate: '2024-03-20T17:00:00.000Z',
          weightage: 10,
          actions: {
            created: mockUserAction,
          },
        },
      ],
      [EAssessmentType.PROJECT]: [
        {
          assessmentId: 'ASSESS-CLASS-6-PROJECT-1',
          name: 'Class 6 - History Project',
          description: 'History research project',
          assessmentType: EAssessmentType.PROJECT,
          status: EAssessmentStatus.GRADED,
          classId: 6,
          maxScore: 30,
          totalStudents: 93,
          averageScore: 25.5,
          averagePercentage: 85,
          dueDate: '2024-03-10T17:00:00.000Z',
          conductedDate: '2024-03-10T17:00:00.000Z',
          gradedDate: '2024-03-15T18:00:00.000Z',
          weightage: 15,
          actions: {
            created: mockUserAction,
          },
        },
      ],
      [EAssessmentType.QUIZ]: [
        {
          assessmentId: 'ASSESS-CLASS-6-QUIZ-1',
          name: 'Class 6 - Math Quiz',
          description: 'Mathematics quick quiz',
          assessmentType: EAssessmentType.QUIZ,
          status: EAssessmentStatus.GRADED,
          classId: 6,
          maxScore: 10,
          totalStudents: 97,
          averageScore: 8.2,
          averagePercentage: 82,
          conductedDate: '2024-02-08T10:00:00.000Z',
          gradedDate: '2024-02-09T18:00:00.000Z',
          weightage: 5,
          actions: {
            created: mockUserAction,
          },
        },
      ],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [
        {
          assessmentId: 'ASSESS-CLASS-6-FINAL-1',
          name: 'Class 6 - Final Exam',
          description: 'Final comprehensive examination',
          assessmentType: EAssessmentType.FINAL,
          status: EAssessmentStatus.SCHEDULED,
          classId: 6,
          maxScore: 100,
          scheduledDate: '2024-05-15T09:00:00.000Z',
          weightage: 35,
          actions: {
            created: mockUserAction,
          },
        },
      ],
    },
    totalAssessments: 8,
    averageScore: 38.2,
    averagePercentage: 76.4,
    completionRate: 75,
  },
  {
    id: 7,
    classDetails: {
      name: 'Class 6B',
      standardLevel: EStandardLevel.CLASS_6,
      section: EAcademicSection.B,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 8,
    classDetails: {
      name: 'Class 7A',
      standardLevel: EStandardLevel.CLASS_7,
      section: EAcademicSection.A,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 9,
    classDetails: {
      name: 'Class 7B',
      standardLevel: EStandardLevel.CLASS_7,
      section: EAcademicSection.B,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 10,
    classDetails: {
      name: 'Class 8A',
      standardLevel: EStandardLevel.CLASS_8,
      section: EAcademicSection.A,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 11,
    classDetails: {
      name: 'Class 8B',
      standardLevel: EStandardLevel.CLASS_8,
      section: EAcademicSection.B,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 12,
    classDetails: {
      name: 'Class 9A',
      standardLevel: EStandardLevel.CLASS_9,
      section: EAcademicSection.A,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 13,
    classDetails: {
      name: 'Class 9B',
      standardLevel: EStandardLevel.CLASS_9,
      section: EAcademicSection.B,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 14,
    classDetails: {
      name: 'Class 10A',
      standardLevel: EStandardLevel.CLASS_10,
      section: EAcademicSection.A,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 15,
    classDetails: {
      name: 'Class 10B',
      standardLevel: EStandardLevel.CLASS_10,
      section: EAcademicSection.B,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 17,
    classDetails: {
      name: 'Class 11 Science B',
      standardLevel: EStandardLevel.CLASS_11,
      section: EAcademicSection.B,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 19,
    classDetails: {
      name: 'Class 11 Arts',
      standardLevel: EStandardLevel.CLASS_11,
      section: EAcademicSection.A,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 20,
    classDetails: {
      name: 'Class 12 Science A',
      standardLevel: EStandardLevel.CLASS_12,
      section: EAcademicSection.A,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 21,
    classDetails: {
      name: 'Class 12 Science B',
      standardLevel: EStandardLevel.CLASS_12,
      section: EAcademicSection.B,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 22,
    classDetails: {
      name: 'Class 12 Commerce',
      standardLevel: EStandardLevel.CLASS_12,
      section: EAcademicSection.B,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 23,
    classDetails: {
      name: 'Class 12 Arts',
      standardLevel: EStandardLevel.CLASS_12,
      section: EAcademicSection.A,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 24,
    classDetails: {
      name: 'Class 12 Vocational',
      standardLevel: EStandardLevel.CLASS_12,
      section: EAcademicSection.B,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
  {
    id: 25,
    classDetails: {
      name: 'Class 11 Vocational',
      standardLevel: EStandardLevel.CLASS_11,
      section: EAcademicSection.B,
      strength: 100,
    },
    assessments: {
      [EAssessmentType.EXAM]: [],
      [EAssessmentType.TEST]: [],
      [EAssessmentType.ASSIGNMENT]: [],
      [EAssessmentType.PROJECT]: [],
      [EAssessmentType.QUIZ]: [],
      [EAssessmentType.MID_TERM]: [],
      [EAssessmentType.FINAL]: [],
    },
    totalAssessments: 0,
    averageScore: 0,
    averagePercentage: 0,
    completionRate: 0,
  },
];

export const mockAcademicsAssessmentClassStatistics: IAcademicsAssessmentStatistics =
  {
    totalAssessments: 100,
    totalClasses: 100,
    totalCourses: 100,
    averageScore: 100,
    averagePercentage: 100,
    completionRate: 100,
    scheduledAssessments: 100,
    completedAssessments: 100,
    inProgressAssessments: 100,
    assessmentsByType: {
      [EAssessmentType.EXAM]: 100,
      [EAssessmentType.TEST]: 100,
      [EAssessmentType.ASSIGNMENT]: 100,
      [EAssessmentType.PROJECT]: 100,
      [EAssessmentType.QUIZ]: 100,
      [EAssessmentType.MID_TERM]: 100,
      [EAssessmentType.FINAL]: 100,
    },
  };
